/* eslint-disable react/button-has-type */
/* eslint-disable no-console */
/* eslint-disable no-shadow */
import React, {
  useEffect, useContext, useRef, useState, useMemo
} from 'react'
import { useLocation } from 'react-router'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Heading2 from '@apps/components/Typography/Heading2'
import ChoosePhoneOption from '@apps/components/ChoosePhoneOption'
import LocationSelector from '@apps/components/LocationSelector'
import {
  PHONE_NUMBER_OPTIONS, PAYMENT_OPTIONS, PORT_ORDER_AUTH_TYPE, PAGE_NUMBER
} from '@apps/utils/constants'
import {
  ACCOUNT_SETUP_STATE
} from '@apps/redux/features/AccountSetupSlice'
import { PHONE_NUMBER_STATE, updatePhoneNumberState } from '@apps/redux/features/PhoneNumberSlice'
import { PAYMENT_STATE, updatePaymentStates, referAFriend as referAFriendInitState } from '@apps/redux/features/PayAndReviewSlice'
import { PLANS_STATE } from '@apps/redux/features/PlansSlice'
import { APPLICATION_STATE, ApplicationContext, setLandingLogicLoader } from '@apps/contexts/ApplicationContext'
import ConsumerActivationPaths from '@sites/consumer/activation/ConsumerActivationPaths'
import DealerActivationPaths from '@sites/dealer/activation/DealerActivationPaths'
import { setPageAnalytics } from '@apps/utils/Analytics'
import TransferNumber from '@apps/components/TransferNumber'
import { getById, getBySlug } from '@apps/utils/contentful'
import Sites from '@sites/index'
import PhoneNumberChangeHandlers, {
  PHONE_NUMBER_EVENTS
} from '@apps/utils/ChangeHandlers/PhoneNumberChangeHandlers'
import CheckoutLayout from '@apps/components/CheckoutLayout'
import {
  Button, Card, CardInfo, Divider, Spacer,
  Typography
} from '@telus/koodo-ui-kit'
import PhoneNumberUnavailablePopup from '@/apps/components/PhoneNumberUnavailablePopup'
import { ANALYTICS_EVENT_TYPES } from '@/apps/utils/constants'
import useTagManagerInfo from '../../_engine/hooks/useTagManagerInfo'
import MarkdownRenderer from '@/apps/components/MarkdownRenderer'

const PhoneNumberPage = () => {
  const dispatch = useDispatch()
  const {
    userType,
    user: { email, accountInfo },
    quote: { quoteInfo }
  } = useSelector((state) => state.common)
  const { [PLANS_STATE.PRE_SELECTED_PLAN]: preSelectedPlan, plan } = useSelector(
    (state) => state.plansPage
  )
  const phoneNumberState = useSelector((state) => state.phoneNumberPage)
  const {
    content: { pageContent, featureFlags }
  } = useSelector((state) => state.common)
  const { simType } = useSelector((state) => state.simSelectionPage.selectSimType || {})
  const { enableMultiPromo } = featureFlags?.[0] || {}

  const { UserData } = useSelector((state) => state.common.quote.quoteInfo)

  const [showPhoneNumberUnavailable, setShowPhoneNumberUnavailable] = useState(false)


  const consumerActivationPaths = new ConsumerActivationPaths()
  const dealerActivationPaths = new DealerActivationPaths()

  const {
    [APPLICATION_STATE.CURRENT_LANGUAGE]: language,
    [APPLICATION_STATE.CURRENT_REGION]: region,
    [APPLICATION_STATE.PROVINCE_GROUPS]: mappedProvinceGroupsList,
    [APPLICATION_STATE.PROVINCES]: mappedProvinceList,
    [APPLICATION_STATE.SERVICES]: { isEligibleForPort, setPatchQuote },
    [APPLICATION_STATE.IDENTITY]: identity
  } = useContext(ApplicationContext)

  const accountSetupPageState = useSelector((state) => state.accountSetupPage)

  const {
    [ACCOUNT_SETUP_STATE.FIRST_NAME]: accountFirstName,
    [ACCOUNT_SETUP_STATE.LAST_NAME]: accountLastName
  } = accountSetupPageState

  const {
    [PHONE_NUMBER_STATE.SELECTED_PHONE_NUMBER_OPTION]: selectedPhoneNumberOption,
    [PHONE_NUMBER_STATE.SELECTED_PHONE_NUMBER]: selectedPhoneNumber,
    [PHONE_NUMBER_STATE.CREATE_NEW_NUMBER.PHONE_NUMBER]: phoneNumberInfo,
    [PHONE_NUMBER_STATE.IS_COMPLETE]: isComplete,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.IS_PORT_IN_AGREEMENT_CHECKED]: isPortInAgreementChecked,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.IS_PORT_IN_WIRELESS]: isPortInWireless,
    [PHONE_NUMBER_STATE.PROVINCE_ID]: provID,
    [PHONE_NUMBER_STATE.CREATE_NEW_NUMBER.PROVINCE_GROUP_ID]: provinceGroupId,
    [PHONE_NUMBER_STATE.CREATE_NEW_NUMBER.CITY_NAME]: newNumberCityName,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.ALTERNATE_CONTACT_NUMBER]: alternateContactNumber,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELINE.STREET_NUMBER]: streetNumber,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELINE.STREET_NAME]: streetName,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELINE.CITY_NAME]: cityName,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELESS
      .PREVIOUS_PROVIDER_ACCOUNT_NUMBER]: prevProviderAccountNumber,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELESS.IMEI]: imeiNumber,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELESS
      .PREVIOUS_PROVIDER_ACCOUNT_NUMBER]: previousProviderAccountNumber,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELINE.FIRST_NAME]: billingFirstName,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELINE.LAST_NAME]: billingLastName,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELINE.STREET_NUMBER]: billingStreetNumber,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELINE.STREET_NAME]: billingStreetName,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELINE.CITY_NAME]: billingCity,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELINE.SELECTED_PROVINCE_LANDLINE]: billingProvince,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELINE.POSTAL_CODE_LANDLINE]: billingPostalCode,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELINE.INTERNET_AND_TV_SERVICES]: serviceAction,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELESS.SELECTED_SPID]: selectedSpid,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.PORT_IN_PHONE_NUMBER]: portInPhoneNumber,
    [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.PREV_PORT_IN_PHONE_NUMBER]: prevPortInPhoneNumber
  } = phoneNumberState

  const { currentProvinceId } = useSelector((state) => state.common)

  const paymentState = useSelector((state) => state.payAndReviewPage)
  const {
    [PAYMENT_STATE.PROMO.MULTI_PROMO_CODES]: multiPromoCodes
  } = paymentState

  const history = useHistory()

  const isDealer = useMemo(() => {
    return userType === Sites.dealer
  }, [userType])

  const pagePrefix = isDealer ? 'Dealer' : 'Consumer'
  const phoneNumberPageContent = getById(pageContent, `phoneNumberPage${pagePrefix}`) || {}
  const plansPageContent = getById(pageContent, `plansPage${pagePrefix}`) || {}
  const autoPromoText = getBySlug(plansPageContent[language]?.shortTextFields, 'autoPromoText')?.value

  const { shortTextFields, longTextFields } = phoneNumberPageContent[language] || {}

  const textContent = useMemo(() => {
    return {
      alternateContactInvalid: getBySlug(shortTextFields, 'alternateContactInvalid')?.value,
      alternateContactRequired: getBySlug(shortTextFields, 'alternateContactRequired')?.value,
      cityRequired: getBySlug(shortTextFields, 'cityRequired')?.value,
      cityInvalid: getBySlug(shortTextFields, 'cityInvalid')?.value,
      completeOneOfError: getBySlug(shortTextFields, 'completeOneOfError')?.value,
      createNumberSubInfo: getBySlug(shortTextFields, 'createNumberSubInfo')?.value,
      disconnectBoth: getBySlug(shortTextFields, 'disconnectBoth')?.value,
      disconnectInternet: getBySlug(shortTextFields, 'disconnectInternet')?.value,
      disconnectTV: getBySlug(shortTextFields, 'disconnectTV')?.value,
      firstNameRequired: getBySlug(shortTextFields, 'firstNameRequired')?.value,
      imeiInvalid: getBySlug(shortTextFields, 'imeiInvalid')?.value,
      lastNameRequired: getBySlug(shortTextFields, 'lastNameRequired')?.value,
      nextStepPayment: getBySlug(shortTextFields, 'nextStepPayment')?.value,
      nextStepPlans: getBySlug(shortTextFields, 'nextStepPlans')?.value,
      noChange: getBySlug(shortTextFields, 'noChange')?.value,
      phoneInvalid: getBySlug(shortTextFields, 'phoneInvalid')?.value,
      postalCodeInvalid: getBySlug(shortTextFields, 'postalCodeInvalid')?.value,
      postalCodeRequired: getBySlug(shortTextFields, 'postalCodeRequired')?.value,
      provinceInvalid: getBySlug(shortTextFields, 'provinceInvalid')?.value,
      provinceRequired: getBySlug(shortTextFields, 'provinceRequired')?.value,
      phoneRequired: getBySlug(shortTextFields, 'phoneRequired')?.value,
      previousAccountNumberInvalid: getBySlug(shortTextFields, 'previousAccountNumberInvalid')
        ?.value,
      serviceRequired: getBySlug(shortTextFields, 'serviceRequired')?.value,
      serviceInvalid: getBySlug(shortTextFields, 'serviceInvalid')?.value,
      streetNameRequired: getBySlug(shortTextFields, 'streetNameRequired')?.value,
      streetNumRequired: getBySlug(shortTextFields, 'streetNumRequired')?.value,
      validCanadianNumber: getBySlug(shortTextFields, 'validCanadianNumber')?.value,
      inEligiblePortInNumberTitle: getBySlug(shortTextFields, 'inEligiblePortInNumberTitle')?.value,
      inEligiblePortInNumberMessage: getBySlug(shortTextFields, 'inEligiblePortInNumberMessage')?.value,
      inEligiblePortInNumberButtonLabel: getBySlug(shortTextFields, 'inEligiblePortInNumberButtonLabel')?.value,
      serviceProviderDate: getBySlug(longTextFields, 'serviceProviderDate')?.value,
      newPhoneNumberOption: getBySlug(shortTextFields, 'new-phone-number-option')?.value,
      transferExistingNumberOption: getBySlug(shortTextFields, 'transfer-existing-number-option')
        ?.value,
      headerTitle: getBySlug(shortTextFields, 'headerTitle')?.value,
      comingFromMessageTitle: getBySlug(shortTextFields, 'comingFromMessageTitle')?.value,
      comingFromMessageBody: getBySlug(longTextFields, 'comingFromMessageBody')?.value,
      phoneNumber: getBySlug(shortTextFields, 'phoneNumber')?.value,
      continueBtn: getBySlug(shortTextFields, 'continueBtn')?.value,
      chooseNumberHeading: getBySlug(shortTextFields, 'chooseNumberHeading')?.value,
      transferNumberHeading: getBySlug(shortTextFields, 'transferNumberHeading')?.value,
      transferNumberBody: getBySlug(shortTextFields, 'transferNumberBody')?.value
    }
  }, [shortTextFields, longTextFields])

  const {
    alternateContactInvalid,
    alternateContactRequired,
    cityRequired,
    cityInvalid,
    completeOneOfError,
    createNumberSubInfo,
    disconnectBoth,
    disconnectInternet,
    disconnectTV,
    firstNameRequired,
    imeiInvalid,
    lastNameRequired,
    nextStepPayment,
    nextStepPlans,
    noChange,
    phoneInvalid,
    postalCodeInvalid,
    postalCodeRequired,
    provinceRequired,
    provinceInvalid,
    phoneRequired,
    previousAccountNumberInvalid,
    serviceRequired,
    serviceInvalid,
    streetNameRequired,
    streetNumRequired,
    validCanadianNumber,
    inEligiblePortInNumberTitle,
    inEligiblePortInNumberMessage,
    inEligiblePortInNumberButtonLabel,
    serviceProviderDate,
    newPhoneNumberOption,
    transferExistingNumberOption,
    headerTitle,
    comingFromMessageTitle,
    comingFromMessageBody,
    phoneNumber,
    continueBtn,
    chooseNumberHeading,
    transferNumberHeading,
    transferNumberBody
  } = textContent

  const nextStepLabel = preSelectedPlan ? nextStepPayment : nextStepPlans

  const serviceProviders = serviceProviderDate ? JSON.parse(serviceProviderDate)[language].copy?.serviceProvider || [] : []
  const SPIDS = serviceProviders?.map(item => ({
    value: item?.value,
    name: item?.name
  }))

  const updatePaymentStore = (payload) => {
    dispatch(updatePaymentStates(payload))
  }

  const location = useLocation()

  const tagManagerInfo = useTagManagerInfo({
    plan_name: plan?.sluggedName || 'NA',
    plan_cost: plan?.value || 'NA',
    customer_ban: 'NA',
    customer_quote_id: accountInfo?.quoteId || quoteInfo?.quoteId || 'NA',
    dealer_info: userType === Sites.dealer ? identity : 'NA',
    journey_type: simType
  })

  const pushTagManagerToDataLayer = () => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(
      setPageAnalytics(location, 'form', region, language, tagManagerInfo)
    )
  }

  // eslint-disable-next-line camelcase
  const pushClickAnalytics = (click_text, event_type = ANALYTICS_EVENT_TYPES.CLICK, event_click = ANALYTICS_EVENT_TYPES.CLICK) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(
      setPageAnalytics(
        location,
        'click',
        region,
        language,
        {
          ...tagManagerInfo,
          // eslint-disable-next-line camelcase
          click_text
        },
        event_type,
        event_click
      )
    )
  }

  useEffect(() => {
    if (userType === Sites.dealer && identity) {
      setTimeout(() => {
        pushTagManagerToDataLayer()
      }, 0)
    }
  }, [region, language, identity])

  useEffect(() => {
    if (userType === Sites.consumer) {
      setTimeout(() => {
        pushTagManagerToDataLayer()
      }, 0)
    }
  }, [region, language])

  useEffect(() => {
    const splashPage = featureFlags && featureFlags[0]?.showSplashing
    if (splashPage) {
      if (isDealer) history.push(dealerActivationPaths.Splash)
      else history.push(consumerActivationPaths.Splash)
    }
  }, [featureFlags, isDealer, history])

  useEffect(() => {
    const defaultState = {
      ...paymentState,
      ...referAFriendInitState,
      [PAYMENT_STATE.RAF.FRIEND_REFERRAL_CODE_IS_VALID]: false,
      [PAYMENT_STATE.SELECTED_PAYMENT_OPTION]: PAYMENT_OPTIONS.CREDIT_CARD,
      [PAYMENT_STATE.CC_INFO.POSTAL_CODE]: '',
      [PAYMENT_STATE.CC_INFO.CC_API_VALIDATION_ERROR]: ''
    }

    if (enableMultiPromo) {
      // If plan has auto promo and multiPromoCodes has more than one, keep only auto promo
      if (plan?.promo && multiPromoCodes?.length > 1) {
        defaultState[PAYMENT_STATE.PROMO.MULTI_PROMO_CODES] = [autoPromoText]
        defaultState[PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_INFO] = [plan.promo]
      } else if (!plan?.promo && multiPromoCodes?.length > 0) {
        // If no auto promo but multiPromoCodes exist, reset all promos
        defaultState[PAYMENT_STATE.PROMO.MULTI_PROMO_CODES] = []
        defaultState[PAYMENT_STATE.PROMO.MULTI_PROMOTION_CODE_INFO] = []
      }
    }

    updatePaymentStore(defaultState)
  }, [language])

  const phoneRef = useRef(null)
  const provinceRef = useRef(null)
  const cityRef = useRef(null)
  const alternateRef = useRef(null)
  const accountRef = useRef(null)
  const imeiRef = useRef(null)
  const prevProvRef = useRef(null)
  const firstNameRef = useRef(null)
  const alternateLandlineRef = useRef(null)
  const streetNameRef = useRef(null)
  const provinceLandlineRef = useRef(null)
  const cityLandlineRef = useRef(null)
  const postalRef = useRef(null)
  const tvInternetRef = useRef(null)
  const streetNumRef = useRef(null)

  const updatePhoneNumberStore = (payload) => {
    dispatch(updatePhoneNumberState(payload))
  }

  useEffect(() => {
    return () => {
      updatePhoneNumberStore({
        [PHONE_NUMBER_STATE.PROVINCE_ID_ERROR]: ''
      })
    }
  }, [preSelectedPlan])

  const onNumberOptionSelect = (name) => {
    updatePhoneNumberStore({
      [PHONE_NUMBER_STATE.SELECTED_PHONE_NUMBER_OPTION]: name
    })
    if (name === PHONE_NUMBER_OPTIONS.TRANSFER_NUMBER || (name === PHONE_NUMBER_OPTIONS.CHOOSE_A_NEW_NUMBER && !PHONE_NUMBER_STATE.PROVINCE_ID)) {
      updatePhoneNumberStore({
        [PHONE_NUMBER_STATE.PROVINCE_ID]: ''
      })
    }
  }

  useEffect(() => {
    if (
      UserData?.portIn &&
      !UserData.phoneNumber &&
      !UserData.portInformation &&
      !portInPhoneNumber &&
      !prevPortInPhoneNumber &&
      !selectedPhoneNumber &&
      selectedPhoneNumberOption !== PHONE_NUMBER_OPTIONS.TRANSFER_NUMBER
    ) {
      updatePhoneNumberStore({
        [PHONE_NUMBER_STATE.SELECTED_PHONE_NUMBER_OPTION]: PHONE_NUMBER_OPTIONS.TRANSFER_NUMBER
      })
      setShowPhoneNumberUnavailable(true)
      pushClickAnalytics(inEligiblePortInNumberTitle, ANALYTICS_EVENT_TYPES.POPUP)
    }
  }, [])

  useEffect(() => {
    if (selectedPhoneNumberOption === PHONE_NUMBER_OPTIONS.CHOOSE_A_NEW_NUMBER) {
      pushClickAnalytics(newPhoneNumberOption, newPhoneNumberOption)
    } else {
      pushClickAnalytics(transferExistingNumberOption, transferExistingNumberOption)
    }
  }, [selectedPhoneNumberOption])

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (action === 'pop' || action === 'POP') {
        return false
      }

      return () => {
        unblock()
      }
    })
  }, [history])

  // Early return to prevent flash of content or downstream effects (analytics, data fetches)
  // before the redirect completes. Only suppress rendering once featureFlags are confirmed
  // loaded, so we don't blank the page on the first paint before the flags arrive.
  const featureFlagsLoaded = Array.isArray(featureFlags) && featureFlags.length > 0
  const showSplashingFlag = featureFlagsLoaded && featureFlags[0]?.showSplashing
  if (showSplashingFlag) {
    return null
  }

  const handleSelectTransferNumberIfInEligible = () => {
    pushClickAnalytics(inEligiblePortInNumberButtonLabel, inEligiblePortInNumberButtonLabel)
    setShowPhoneNumberUnavailable(false)
  }

  const updateQuote = async () => {
    try {
      const input = { email, userData: {} }
      if (selectedPhoneNumberOption === PHONE_NUMBER_OPTIONS.CHOOSE_A_NEW_NUMBER) {
        input.provinceId = provID
        input.userData.phoneNumber = selectedPhoneNumber
        input.userData.phoneNumberId = phoneNumberInfo.id
        input.userData.portIn = false
        input.userData.cityName = newNumberCityName
        input.userData.provinceGroupId = provinceGroupId
      } else if (selectedPhoneNumberOption === PHONE_NUMBER_OPTIONS.TRANSFER_NUMBER) {
        input.provinceId = currentProvinceId
        input.userData.portIn = true
        input.userData.phoneNumber = `${selectedPhoneNumber}`
        if (isPortInWireless) {
          const portInformation = {
            isWireless: isPortInWireless,
            authType: imeiNumber ? PORT_ORDER_AUTH_TYPE.SERIAL_NUMBER : PORT_ORDER_AUTH_TYPE.ACCOUNT,
            authValue: imeiNumber || previousProviderAccountNumber,
            authorizationName: `${accountFirstName} ${accountLastName}`,
            contactNumber: alternateContactNumber.replaceAll(' ', ''),
            serviceProvider: selectedSpid,
            reseller: '',
            serviceAction: '',
            billing: {
              billingCity: '',
              billingStreetNumber: '',
              billingStreetName: '',
              billingFirstName: '',
              billingLastName: '',
              billingProvince: '',
              billingPostalCode: ''
            }
          }
          input.userData.portInformation = portInformation
        } else {
          const { shortName = '' } = mappedProvinceList.find((group) => {
            return group.value === billingProvince
          }) || {}
          const portInformation = {
            isWireless: isPortInWireless,
            authType: PORT_ORDER_AUTH_TYPE.NONE,
            authValue: null,
            authorizationName: `${accountFirstName} ${accountLastName}`,
            contactNumber: alternateContactNumber.replaceAll(' ', ''),
            serviceProvider: null,
            reseller: '',
            serviceAction,
            billing: {
              billingCity,
              billingStreetNumber,
              billingStreetName,
              billingFirstName,
              billingLastName,
              billingProvince: shortName,
              billingPostalCode
            }
          }
          input.userData.portInformation = portInformation
        }
      }
      const response = await setPatchQuote(input)
      return response
    } catch (err) {
      console.log('UPDATE QUOTE: PHONE NUMBER SELECTION ERROR', err)
      return err
    }
  }

  const handleNextClick = async () => {
    try {
      pushClickAnalytics(nextStepLabel, nextStepLabel)
      setLandingLogicLoader('IN_PROGRESS')
      if (isComplete) {
        const updateQuoteResponse = await updateQuote()
        const nextConsumerPath = preSelectedPlan
          ? consumerActivationPaths.Payment
          : consumerActivationPaths.Plans

        const nextPagePath = isDealer ? dealerActivationPaths.Plans : nextConsumerPath

        const splashPagePath = isDealer
          ? dealerActivationPaths.Splash
          : consumerActivationPaths.Splash

        const hasHardError =
          updateQuoteResponse instanceof Error
          || !!updateQuoteResponse?.error
          || Number(updateQuoteResponse?.response?.status) >= 400
        const hasQuoteIdentity =
          !!updateQuoteResponse?.data?.accountId
          || !!updateQuoteResponse?.data?.quoteId
        const hasExplicitSuccess =
          updateQuoteResponse?.success === true
          || updateQuoteResponse?.ok === true

        // Plans flow should not be blocked by strict `accountId` checks;
        // PATCH quote responses can vary by environment and still be valid.
        const shouldProceed = !hasHardError
          && (hasQuoteIdentity || hasExplicitSuccess || (!isDealer && !preSelectedPlan))

        if (shouldProceed) {
          history.push(nextPagePath)
        } else {
          history.push(splashPagePath)
        }
      } else {
        let topError
        if (selectedPhoneNumberOption === PHONE_NUMBER_OPTIONS.CHOOSE_A_NEW_NUMBER) {
          const prov = mappedProvinceList?.find((item) => {
            return item.value === provID
          })
          let name = ''
          if (prov) {
            const { label: { en = '', fr = '' } = {} } = prov
            name = language === 'en' ? en : fr
          }
          if (handleBlurProvince(name) && !topError) {
            topError = provinceRef
          }
          if (handleBlurCity() && !topError) {
            topError = cityRef
          }
        } else {
          if ((await handleBlurPhone()) && !topError) {
            topError = phoneRef
          }
          if (!isPortInAgreementChecked) {
            updatePhoneNumberStore({
              [PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.IS_PORT_IN_HAS_AGREEMENT_ERROR]: true
            })
            if (!topError) {
              topError = phoneRef
            }
          }

          if (isPortInWireless) {
            if (handlePrevProvider() && !topError) {
              topError = prevProvRef
            }
            if (handleIMEI() && !topError) {
              topError = imeiRef
            }
            if (handleAccount(prevProviderAccountNumber) && !topError) {
              topError = accountRef
            }
            if (handleAltPhone() && !topError) {
              topError = alternateRef
            }
          } else {
            if (handleFirstName(billingFirstName) && !topError) {
              topError = firstNameRef
            }
            if (handleLastName(billingLastName) && !topError) {
              topError = firstNameRef
            }
            if (handleStreetNum(streetNumber) && !topError) {
              topError = streetNumRef
            }
            if (handleStreetName(streetName) && !topError) {
              topError = streetNameRef
            }
            if (handleProvince() && !topError) {
              topError = provinceLandlineRef
            }
            if (handleCity(cityName) && !topError) {
              topError = cityRef
            }
            if (handlePostal() && !topError) {
              topError = postalRef
            }
            if (handleTVInternet() && !topError) {
              topError = tvInternetRef
            }
            if (handleAltPhoneLandline(alternateContactNumber) && !topError) {
              topError = alternateLandlineRef
            }
          }
        }
        if (topError) {
          topError.current.scrollIntoView({
            behavior: 'smooth'
          })
        }
      }
    } finally {
      setLandingLogicLoader(false)
    }
  }

  let provinces = []

  if (mappedProvinceList) {
    provinces = mappedProvinceList.map((item) => {
      const { label, value } = item
      return {
        value,
        name: label[language]
      }
    })
  }

  const handleBlurProvince = (provinceValue) => {
    const errorCopy = {
      cityRequired,
      cityInvalid,
      provinceRequired,
      provinceInvalid
    }
    return PhoneNumberChangeHandlers[PHONE_NUMBER_EVENTS.PROVINCE].onBlur(
      phoneNumberState,
      provinces,
      errorCopy,
      provinceValue,
      updatePhoneNumberStore
    )
  }

  const handleBlurCity = () => {
    let cities = []
    if (mappedProvinceGroupsList) {
      cities = mappedProvinceGroupsList
    }
    return PhoneNumberChangeHandlers[PHONE_NUMBER_EVENTS.PROVINCE_GROUP].onBlur(
      phoneNumberState,
      cities,
      updatePhoneNumberStore
    )
  }

  const handleBlurPhone = async () => {
    const phoneCheck = PhoneNumberChangeHandlers[PHONE_NUMBER_EVENTS.PHONE_NUMBER].onBlur(
      phoneNumberState,
      phoneRequired,
      phoneInvalid,
      isEligibleForPort,
      validCanadianNumber,
      updatePhoneNumberStore
    )

    if (phoneCheck) {
      return true
    }

    return false
  }

  const handlePrevProvider = () => {
    return PhoneNumberChangeHandlers[PHONE_NUMBER_EVENTS.SPID].onBlur(
      phoneNumberState,
      SPIDS,
      updatePhoneNumberStore
    )
  }

  const handleIMEI = () => {
    const errors = {
      requiredErrorMessage: completeOneOfError,
      invalidErrorMessage: imeiInvalid
    }

    return PhoneNumberChangeHandlers[PHONE_NUMBER_EVENTS.IMEI].onBlur(
      phoneNumberState,
      errors,
      updatePhoneNumberStore
    )
  }

  const handleAccount = (value) => {
    const errors = {
      requiredErrorMessage: completeOneOfError,
      invalidErrorMessage: previousAccountNumberInvalid
    }
    return PhoneNumberChangeHandlers[PHONE_NUMBER_EVENTS.ACCOUNT_NUMBER].onBlur(
      phoneNumberState,
      errors,
      value.length,
      updatePhoneNumberStore
    )
  }

  const MAX_LENGTH_ALTERNATE_PHONE_NUMBER = 12

  const handleAltPhone = () => {
    return PhoneNumberChangeHandlers[PHONE_NUMBER_EVENTS.ALTERNATE_CONTACT_NUMBER].onBlur(
      phoneNumberState,
      {
        requiredErrorMessage: alternateContactRequired,
        invalidErrorMessage: alternateContactInvalid
      },
      MAX_LENGTH_ALTERNATE_PHONE_NUMBER,
      updatePhoneNumberStore
    )
  }

  const handleFirstName = (value) => {
    return PhoneNumberChangeHandlers[PHONE_NUMBER_EVENTS.INPUT].onBlur(
      value,
      PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELINE.FIRST_NAME_ERROR,
      firstNameRequired,
      'First name must contain letters and a max 11 characters',
      updatePhoneNumberStore,
      value.length
    )
  }

  const handleLastName = (value) => {
    return PhoneNumberChangeHandlers[PHONE_NUMBER_EVENTS.INPUT].onBlur(
      value,
      PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELINE.LAST_NAME_ERROR,
      lastNameRequired,
      'Last name must contain letters and a max 18 characters',
      updatePhoneNumberStore,
      value.length
    )
  }

  const handleAltPhoneLandline = (value) => {
    return PhoneNumberChangeHandlers[PHONE_NUMBER_EVENTS.INPUT].onBlur(
      value,
      PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.ALTERNATE_CONTACT_NUMBER_ERROR,
      alternateContactRequired,
      alternateContactInvalid,
      updatePhoneNumberStore,
      MAX_LENGTH_ALTERNATE_PHONE_NUMBER
    )
  }

  const handleStreetNum = (value) => {
    return PhoneNumberChangeHandlers[PHONE_NUMBER_EVENTS.INPUT].onBlur(
      value,
      PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELINE.STREET_NUMBER_ERROR,
      streetNumRequired,
      '',
      updatePhoneNumberStore,
      value.length
    )
  }
  const handleStreetName = (value) => {
    return PhoneNumberChangeHandlers[PHONE_NUMBER_EVENTS.INPUT].onBlur(
      value,
      PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELINE.STREET_NAME_ERROR,
      streetNameRequired,
      '',
      updatePhoneNumberStore,
      value.length
    )
  }
  const handleProvince = () => {
    const errorCopy = {
      provinceRequired,
      provinceInvalid
    }
    return PhoneNumberChangeHandlers[PHONE_NUMBER_EVENTS.PROVINCE_LANDLINE].onBlur(
      phoneNumberState,
      provinces,
      errorCopy,
      updatePhoneNumberStore
    )
  }

  const handleCity = (value) => {
    return PhoneNumberChangeHandlers[PHONE_NUMBER_EVENTS.INPUT].onBlur(
      value,
      PHONE_NUMBER_STATE.TRANSFER_A_NUMBER.WIRELINE.CITY_NAME_ERROR,
      cityRequired,
      '',
      updatePhoneNumberStore,
      value.length
    )
  }
  const handlePostal = () => {
    return PhoneNumberChangeHandlers[PHONE_NUMBER_EVENTS.POSTAL_CODE].onBlur(
      phoneNumberState,
      {
        postalCodeRequired,
        postalCodeInvalid
      },
      updatePhoneNumberStore
    )
  }

  const handleTVInternet = () => {
    const tvInternetOptions = [
      {
        name: disconnectBoth,
        value: '0'
      },
      {
        name: disconnectInternet,
        value: '1'
      },
      {
        name: disconnectTV,
        value: '2'
      },
      {
        name: noChange,
        value: '3'
      }
    ]
    const errorCopyInternetAndTv = {
      requiredErrorMessage: serviceRequired,
      invalidErrorMessage: serviceInvalid
    }
    return PhoneNumberChangeHandlers[PHONE_NUMBER_EVENTS.INTERNET_TV].onBlur(
      phoneNumberState,
      tvInternetOptions,
      errorCopyInternetAndTv,
      updatePhoneNumberStore
    )
  }

  const transferRefs = {
    phoneRef,
    alternateRef,
    accountRef,
    imeiRef,
    prevProvRef,
    alternateLandlineRef,
    firstNameRef,
    streetNameRef,
    provinceLandlineRef,
    cityLandlineRef,
    postalRef,
    tvInternetRef,
    streetNumRef
  }
  const transferHandlers = {
    handleBlurPhone,
    handlePrevProvider,
    handleIMEI,
    handleAccount,
    handleAltPhone,
    handleFirstName,
    handleLastName,
    handleAltPhoneLandline,
    handleStreetNum,
    handleStreetName,
    handleProvince,
    handleCity,
    handlePostal,
    handleTVInternet
  }

  return (
    <>
      <CheckoutLayout
        heading={
          <Heading2 className="mt-6 sm:mt-10 max-w-2xl">
            {headerTitle}
          </Heading2>
        }
        activeStepIndex={PAGE_NUMBER.CHOOSE_NUMBER}
      >
        <div className="relative z-10">
          <Card variant={{ padding: 'intermediate', borderRadius: 'large' }}>
            <Typography tokens={{ fontWeight: 700, fontSize: 24 }}>
              {phoneNumber}
            </Typography>
            <div>
              {comingFromMessageTitle && comingFromMessageBody && (
                <div className='mt-6'>
                  <CardInfo
                    heading={comingFromMessageTitle}
                    tokens={{ paddingTop: 16, paddingBottom: 16 }}
                  >
                    <MarkdownRenderer
                      markdown={comingFromMessageBody}
                      onLinkClick={(text) =>
                        pushClickAnalytics(text, text)
                      }
                      paragraphClassForIndex={() => 'text-copy text-sm font-body leading-6 mb-4'}
                      linkPrimaryClass={false}
                    />
                  </CardInfo>
                </div>
              )}
              <div>
                <ChoosePhoneOption
                  onSelect={onNumberOptionSelect}
                  selectedOption={selectedPhoneNumberOption}
                  pushClickAnalytics={pushClickAnalytics}
                />
              </div>
              <Spacer space={4} />
              <Divider />
              {selectedPhoneNumberOption === PHONE_NUMBER_OPTIONS.CHOOSE_A_NEW_NUMBER && (
                <div className="mt-4 text-lg leading-7">
                  <Typography tokens={{ fontWeight: 700, fontSize: 20 }}>
                    {chooseNumberHeading}
                  </Typography>
                  <Spacer space={2} />
                  <Typography tokens={{ fontSize: 16 }}>
                    {createNumberSubInfo}
                  </Typography>
                  <LocationSelector
                    handleBlurProvince={handleBlurProvince}
                    handleBlurCity={handleBlurCity}
                    cityRef={cityRef}
                    provinceRef={provinceRef}
                    pushClickAnalytics={pushClickAnalytics}
                  />
                </div>
              )}
              {selectedPhoneNumberOption === PHONE_NUMBER_OPTIONS.TRANSFER_NUMBER && (
                <div className="mt-4 text-lg leading-7">
                  <Typography tokens={{ fontWeight: 700, fontSize: 20 }}>
                    {transferNumberHeading}
                  </Typography>
                  <Spacer space={2} />
                  <Typography tokens={{ fontSize: 16 }}>
                    {transferNumberBody}
                  </Typography>
                  <TransferNumber
                    transferRefs={transferRefs}
                    transferHandlers={transferHandlers}
                    chooseNewPhoneNumber={() =>
                      onNumberOptionSelect(PHONE_NUMBER_OPTIONS.CHOOSE_A_NEW_NUMBER)
                    }
                    pushClickAnalytics={pushClickAnalytics}
                  />
                </div>
              )}
            </div>
            <div className="mt-12">
              <Button
                onPress={handleNextClick}
                testId="phoneNumber-nextStep"
                variant={{ width: 'responsive' }}
              >
                {continueBtn}
              </Button>
            </div>
            <PhoneNumberUnavailablePopup
              isOpen={showPhoneNumberUnavailable}
              unavailableNumberTitle={inEligiblePortInNumberTitle}
              unavailableNumberMessage={inEligiblePortInNumberMessage}
              selectNewPhoneNumberLabel={inEligiblePortInNumberButtonLabel}
              onClose={handleSelectTransferNumberIfInEligible}
              onNewPhoneNumberClick={handleSelectTransferNumberIfInEligible}
            />
          </Card>
        </div>
      </CheckoutLayout>
    </>
  )
}

export default PhoneNumberPage
